import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 60vh;
  margin-bottom: 70px;

  .dataGrid {
    text-align: center !important;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header button {
    width: auto;
  }

  .MuiDataGrid-root {
    width: 100%;
    height: 100%;
    margin-top: 20px;
  }

  .MuiDataGrid-columnHeader {
    background: #020c90;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    text-align: center !important;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;

    .MuiSvgIcon-root {
      color: #fff;
      opacity: 1 !important;
    }
  }

  .css-1rtnrqa {
    display: none;
  }

  .css-68pk0f {
    width: 40%;

    @media all and (max-width: 768px) {
      width: 100%;
    }
  }

  .css-1knaqv7-MuiButtonBase-root-MuiButton-root {
    display: none;
  }

  .css-3be3ve-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter {
    width: 40%;

    @media all and (max-width: 768px) {
      width: 100%;
    }
  }

  .createdDate {
    display: flex;
    flex-direction: column;
  }

  .MuiDataGrid-virtualScrollerRenderZone {
    text-align: center;
  }

  .button-icon {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      &:hover {
        filter: none;
      }
    }

    img {
      width: 20px;

      &:hover {
        filter: brightness(0) saturate(100%) invert(16%) sepia(41%) saturate(7143%) hue-rotate(237deg) brightness(63%)
          contrast(126%);
      }
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #9a9a9a;
    height: 5px;
    border-radius: 10px;
  }
`;

export const Section = styled.div`
  margin-top: 40px;
  border-bottom: inherit;

  .input-box {
    display: flex;
    flex-direction: column;
    width: 38%;
  }

  .input-title,
  .input-link {
    display: flex;
    width: 100%;
    height: 40px;
  }

  .carousel-list {
    max-height: fit-content;
  }
`;

export const SectionHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const SettingsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding: 10px 0 10px 10px;
  border-radius: 18px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  @media (max-width: 960px) {
    margin: 16px 0;
  }

  .add-image-box {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #d9d9d9;
  }
`;

export const SettingsListItemButtonBox = styled.div`
  display: flex;
  justify-content: space-between;
`;
